import { MultipleChoiceEditComponent } from './edit';
import { MultipleChoicePreviewComponent } from './preview';
import { MultipleChoiceAiChangePreviewComponent } from './ai-change-preview';
import { MultipleChoiceGradingComponent } from './grading/multiple-choice-grading.component';
import { MultipleChoiceReportComponent } from './report/multiple-choice-report.component';
import { MultipleChoiceAnswerComponent } from './answer';
export var MULTIPLE_CHOICE_REGISTRY = {
  edit: MultipleChoiceEditComponent,
  preview: MultipleChoicePreviewComponent,
  'ai-change-preview': MultipleChoiceAiChangePreviewComponent,
  grading: MultipleChoiceGradingComponent,
  report: MultipleChoiceReportComponent,
  answer: MultipleChoiceAnswerComponent
};